import * as React from 'react';
import PropTypes from 'prop-types';
import * as DropIn from 'braintree-web-drop-in';
import { braintreePaymentConfig } from './../../../config'
import Loader from '../../UI/Loader'
import { graphql, compose } from 'react-apollo'
import { translate } from 'react-i18next'

import CREATE_TRANSACTION_MUTATION from './../../../graphql/CreatePaymentTransaction.graphql'

const DROP_IN_CONTAINER_ID = 'drop-in-container';
const DROP_IN_CONTAINER_SELECTOR = `#${DROP_IN_CONTAINER_ID}`;

class DropInComponent extends React.Component {

    brainTreeInstance;
    state = {
        isPaymentReady: false,
        isPaymentComplete: false,
        isPaymentProcessing: false
    };
    
    static propTypes = {
        amount: PropTypes.number,
        handlePostPayment: PropTypes.func,
        completeTransaction: PropTypes.func
    };

    handlePayment = (payload) => {
        this.setState(
            {isPaymentProcessing: true}
        )
      let transaction
      fetch(
          braintreePaymentConfig.REACT_APP_LAMBDA_ROOT + 'pay2',
            {
                method: 'post',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify({
                    "nonce": payload.nonce,
                    "amount": '' + this.props.amount
                })
            }
        )
        .then(response => {
          return response.json()
        })
        .then(result => {
          this.setState(
              {isPaymentComplete: true
            }
          )
          transaction = result.transaction
          // Store the transaction
          this.props.createPaymentTransaction({
            variables: {transactionId : result.transaction.id}
          })         
          .then(res => {
            transaction.dbId = res.data.createPaymentTransaction.id
            this.props.completeTransaction(transaction)
          })
        })
        .catch(
            error => console.log("Fetch failed: " + error)
        )
    };

    componentDidMount() {
        fetch(braintreePaymentConfig.REACT_APP_LAMBDA_ROOT + 'auth')
            .then(res => res.json())
            .then(({ token }) => {
                this.setState({
                    authorization: token
                });

                DropIn.create({
                    container: DROP_IN_CONTAINER_SELECTOR,
                    authorization: this.state.authorization,
                    card: {
                        cardholderName: true
                      },
                    paypal: {
                        flow: 'vault'
                    }
                }, (err, instance) => {
                    if (!err) {
                        this.brainTreeInstance = instance;
                        this.brainTreeInstance.on('paymentMethodRequestable', (method) => {
                            this.setState({ isPaymentReady: true });
                        });
                        this.brainTreeInstance.on('noPaymentMethodRequestable', () => {
                            this.setState({ isPaymentReady: false });
                        });
                    }
                    else {
                        console.error(err.name + ': ' + err.message)
                    }
                });
        
            });
    }

    handleOrder = () => {
        if (this.brainTreeInstance) {
            this.brainTreeInstance.requestPaymentMethod((err, payload) => {
                if (!err) {
                    this.handlePayment(payload);
                }
            });
        }
    };

    render() {
        if (!this.state.authorization || this.state.isPaymentProcessing) {
            return <Loader showLoader={true} />
          }

        const { t } = this.props

        return (
            <div className='drop-in-wrapper'>
                <div id={DROP_IN_CONTAINER_ID}/>
                {this.state.isPaymentReady && !this.state.isPaymentProcessing &&
                <button 
                    className='btn btn-danger'
                    onClick={this.handleOrder}
                >
                    {t('place_order')}
                </button>
                }                
                {this.state.isPaymentComplete &&
                <button
                    className='btn btn-danger'
                    onClick={this.props.handlePostPayment}
                >
                    {t('continue')}
                </button>
                }                
            </div>
        );
    }
}

const enhance = compose(
    translate('payment'),
    graphql(CREATE_TRANSACTION_MUTATION, {
      name: 'createPaymentTransaction'
    })
  )
  
export default enhance(DropInComponent)
  


// WEBPACK FOOTER //
// src/components/payment/DropInComponent/DropInComponent.jsx